import { createContext, useContext, useMemo } from "react";
import { useAccountScopedFetch } from "../../lib/api";
import { AccountsApi, AccountsService } from "decodable-sdk-js/v1alpha2";

export const AccountsApiContext = createContext<AccountsApi>(null);

// Provides an account-scoped Accounts service.
// In tests, use AccountsApiContext.Provider directly
// to inject mock services into containers or components.
export function AccountsApiProvider({ children = null }) {
  const fetch = useAccountScopedFetch();
  const service = useMemo(() => fetch && new AccountsService(fetch), [fetch]);
  return (
    <AccountsApiContext.Provider value={service}>
      {children}
    </AccountsApiContext.Provider>
  );
}

export function useAccountsApi(): AccountsApi | null {
  return useContext(AccountsApiContext);
}
